import privateInstance from "../privateClient";
import mapboxInstance from "../mapboxClient";
import {
  FetchMapBoxConfigurationQueryType,
  GetMapboxLocationDetailsQueryType,
  GetMapboxSearchSuggestionsQueryType,
} from "./types";

export const mapboxApi = {
  getMapboxConfiguration: async () => {
    try {
      const response = await privateInstance.get<
        FetchMapBoxConfigurationQueryType["Data"]
      >("/globalsettings/public-client-credentials");

      return response.data;
    } catch (err) {
      return null;
    }
  },

  getSuggestions: async (
    params: GetMapboxSearchSuggestionsQueryType["Params"],
  ) => {
    try {
      const response = await mapboxInstance.get("/suggest", {
        params: {
          session_token: params.appInstanceId,
          access_token: params.accessToken,
          q: params.searchValue,
          country: "us",
          types: "address,street,postcode,city",
        },
      });

      return response.data;
    } catch (error) {
      return null;
    }
  },

  getLocationDetails: async (
    params: GetMapboxLocationDetailsQueryType["Params"],
  ) => {
    try {
      const response = await mapboxInstance.get(
        `/retrieve/${params.mapboxId}`,
        {
          params: {
            session_token: params.appInstanceId,
            access_token: params.accessToken,
          },
        },
      );

      return response.data;
    } catch (error) {
      return null;
    }
  },
};
